export enum WIZARD_STEPS {
  IMPORT_FILE = 0,
  VERIFY_EDIT_COMPANY_DATA = 1,
}
